module.exports = __webpack_public_path__ + "img/der_02_coin_a.663343c4.png";